import { OfferProgramTermsContext } from "../context/OfferProgramTermsContext";
import { useProviderInitializedContext } from "../../../hooks/useProviderInitializedContext";

export const useOfferProgramTerms = () => {
  return useProviderInitializedContext(OfferProgramTermsContext);
};
